import { Component, Input, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { IUsersActivity, UsersActivityData } from '../../models/usersActivityData';
import { SessionService } from '../../services/session.service';
import { UserData, UserLogoGenerateComponent } from '../user-logo-generate/user-logo-generate.component';
import { SHARED_MODULES } from '../../../shared.';

const MAX_VISIBLE_USERS: number = 4;

@Component({
    selector: 'app-users-activity',
    templateUrl: './users-activity.component.html',
    styleUrls: ['./users-activity.component.scss'],
	imports: [SHARED_MODULES, UserLogoGenerateComponent],
    standalone: true
})
export class UsersActivityComponent implements OnDestroy {

    activeUsers: Array<IUsersActivity> = [];
    isNiqUser: boolean = false;
	isStaffUser: boolean = false;
    maxVisibleUsers: number = MAX_VISIBLE_USERS;
    otherIconData: UserData;
    subscription: Subscription;

    @Input('dataSubject') set setSubject(subject: BehaviorSubject<UsersActivityData>) {
        if (this.subscription) this.subscription.unsubscribe();

        if (subject) {
            this.subscription = subject.subscribe((data: UsersActivityData) => {
                this.activeUsers = data?.activity
                    .filter((user: IUsersActivity) => {
					    const isStaff: boolean = SessionService.isStaff(user.email);
					    return this.isStaffUser || !isStaff; // hide staff users for clients
				    })
                    .filter((user: IUsersActivity) => {
                        const isNiq: boolean = SessionService.isNIQ(user.email);
                        return this.isNiqUser || this.isStaffUser || !isNiq; // hide NiQ users for clients
                    })
                    .filter((user: IUsersActivity) => {
                        return user.opened_tabs > 1 || user.email !== this.sessionService.defaults.email; // hide this user if only this tab is open
                    }) || [];

                if (this.activeUsers.length > MAX_VISIBLE_USERS) {
                    this.otherIconData = {
                        name: '+ ' + (this.activeUsers.length - MAX_VISIBLE_USERS),
                        image: null
                    }
                } else {
                    this.otherIconData = {
                        name: '',
                        image: null
                    }
                }
            });
        }
    }

	constructor(private sessionService: SessionService) {
		this.isStaffUser = SessionService.isStaff(this.sessionService.defaults.email);
        this.isNiqUser = SessionService.isNIQ(this.sessionService.defaults.email);
	}

    ngOnDestroy(): void {
        if (this.subscription) this.subscription.unsubscribe();
    }
}
